import courseApi from "@api/course";
import { useAppContext } from "@context/app";
import { useLayoutContext } from "@context/layout";
import { WatchTimeData } from "@types";
import { useRef } from "react";

const useGuestWatchtime = (productId: number, lessonId: number | null) => {
  const {
    user: { isLoggedIn },
  } = useAppContext();
  const { guestSessionId } = useLayoutContext();
  const watchedData = useRef<WatchTimeData>({
    lastWatchedTime: 0,
    watchedDuration: 0,
    lastWatchedPercent: 0,
  });

  const updateWatchTime = async (time: number, duration: number) => {
    const isGuest = !isLoggedIn;
    if (!lessonId || !productId || !isGuest || !guestSessionId) return;

    try {
      if (watchedData.current.req) watchedData.current.req.cancel();

      const payload = {
        duration: Math.round(duration),
        time: Math.round(time),
        lesson_id: String(lessonId),
        product_id: String(productId),
      };

      watchedData.current.req = courseApi.updateGuestWatchTime({
        ...payload,
        session_id: guestSessionId,
      });

      await watchedData.current.req.fetch();

      const p = Math.max(Math.min(100, Math.round((time * 100) / duration)), 0);
      watchedData.current.lastWatchedPercent = Math.max(
        watchedData.current.lastWatchedPercent,
        p
      );
    } catch (error) {
    } finally {
      watchedData.current.req = undefined;
    }
  };

  const timeUpdateHandler = async (time: number, duration: number) => {
    const diff = time - watchedData.current.lastWatchedTime;
    if (diff <= 1 && diff > 0)
      watchedData.current.watchedDuration +=
        time - watchedData.current.lastWatchedTime;
    if (duration > 0 && watchedData.current.watchedDuration >= 30) {
      watchedData.current.watchedDuration = 0;
      await updateWatchTime(time, duration);
    }
    watchedData.current.lastWatchedTime = time;
  };

  return timeUpdateHandler;
};

export default useGuestWatchtime;
